<template>
  <ul class="flex">
    <li v-for="item in tabs" :key="item.id" class="mr-4">
      <button
        class="text-textSecondaryDark text-2xl font-bold"
        :class="[active === item.id && '!text-hqPurple']"
        @click="onChange(item.id)"
        tabIndex="0"
      >
        {{ item.name }}
      </button>
    </li>
  </ul>
</template>

<script setup>
defineProps({
  tabs: {
    type: Array,
    default: () => [],
  },
  active: {
    type: [String, Number],
    default: "",
  },
  onChange: {
    type: Function,
    default: () => {},
  },
});
</script>
